import { render, staticRenderFns } from "./CustomSelectTemplate.vue?vue&type=template&id=6898ff29&scoped=true&"
import script from "./CustomSelectTemplate.vue?vue&type=script&lang=ts&"
export * from "./CustomSelectTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSelectTemplate.vue?vue&type=style&index=0&id=6898ff29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6898ff29",
  null
  
)

export default component.exports